import React, { Component } from 'react';

import { BundleData } from 'client/bundles/types';

import Management from 'client/components/management';
import Seo from 'client/components/seo';

interface Props {
    data: BundleData;
}

export default class ManagementPage extends Component<Props> {
    render() {
        const { management, pageName, sectionTitle } = this.props.data;

        return (
            <>
                <Seo title={management.title} sectionTitle={sectionTitle} />

                <Management management={management} title={sectionTitle} pageName={pageName} />
            </>
        );
    }
}
